import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function CommunityPage({ user, t, onBack, onLogin }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();

    if (!user) {
      onLogin();
      return;
    }

    try {
      await api.post("/suggestions", { title, description });
      setTitle("");
      setDescription("");
      setMessage("Suggestion submitted.");
      setError("");
    } catch (err) {
      setError(err.response?.data?.detail || "Unable to submit suggestion.");
    }
  };

  return (
    <SimplePage title="Community Suggestions" onBack={onBack}>
      <div className="civic-data-panel">
        <p>
          Share a constructive civic suggestion for improving local public services.
        </p>

        <form onSubmit={submit} className="profile-grid">
          <label>
            Title
            <input value={title} onChange={(e) => setTitle(e.target.value)} required />
          </label>

          <label className="profile-full">
            Description
            <textarea
              rows="6"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </label>

          {message && <div className="profile-success">{message}</div>}
          {error && <div className="profile-error">{error}</div>}

          <button className="civic-btn primary" type="submit">
            Submit Suggestion
          </button>
        </form>
      </div>
    </SimplePage>
  );
}


export default CommunityPage;
